module.exports = {
	"base": {
		"welcome": "Καλώς ορίσατε στο Mulligans %{name}.",
		"user": "Πληροφορίες χρήστη",
		"devices": "Συσκευές",
		"refunds": "Επιστροφές χρημάτων",
		"resources": "Πηγές",
		"transactions": "Συναλλαγές και επιστροφές χρημάτων",
		"email": "Ηλεκτρονικό ταχυδρομείο",
		"password": "Κωδικός πρόσβασης",
		"save": "Αποθήκευση",
		"sign-out": "Έξοδος",
		"cancel": "Άκυρο",
		"close": "Κλείσιμο",
		"learn-more": "Περισσότερα",
		"required": "Απαιτούμενο",
		"support": "Υποστήριξη",
		"bookshelf": "Bookshelf",
		"launch": "Εκκίνηση",
		"download": "Λήψη",
		"details": "Λεπτομέρειες",
		"cannot-be-blank": "%{field} δεν μπορεί να είναι κενό.",
		"saving": "Αποθήκευση…",
		"done": "Τέλος",
		"failed": "Απέτυχε",
		"copy": "Αντιγραφή"
	},
	"signin": {
		"login-failure": "Η διεύθυνση ηλεκτρονικού ταχυδρομείου ή ο κωδικός πρόσβασής σας είναι εσφαλμένα",
		"welcome-large": "Καλώς ορίσατε στον  <span class='inner'>%{brand} λογαριασμό σας</span>",
		"welcome-small": "<span class='inner'>Λογαριασμός</span>",
		"signin-button": "Είσοδος",
		"forgot-password": "Ξεχάσατε τον κωδικό πρόσβασής σας;",
		"new-to-vst": "Νέος χρήστης του %{brand}; ",
		"create-account": "Δημιουργία λογαριασμού",
		"signing-in": "Είσοδος...",
		"signin-failed": "Η σύνδεση απέτυχε"
	},
	"transactions": {
		"price": "Τιμή",
		"excluded": "(Εξαιρείται ο φόρος)",
		"quantity": "Ποσότητα",
		"confirmation#": "Επιβεβαίωση #",
		"payment": "Πληρωμή",
		"purchased": "Αγοράστηκε",
		"purchase-details": "Στοιχεία αγοράς",
		"subtotal": "Μερικό σύνολο",
		"total": "Σύνολο",
		"tax": "Φόρος",
		"loading": "Χαίρετε καλέ μας πελάτη, φορτώνουμε τις συναλλαγές σας ...",
		"no-purchases": "Δεν έχετε αγορές.",
		"seller-vat": "ΦΠΑ Πωλητή",
		"total-vat": "Σύνολο %{vat} καταβληθέντος ποσού",
		"portion": "%{subTax} Φόρος %{rate}%",
		"vat-disclosure": "Η τιμή περιλαμβάνει %{vat}",
		"purchases": "Αγορές",
		"refunded-items": "Επιστρεφόμενα στοιχεία",
		"book-title": "Τίτλος βιβλίου",
		"refund-details": "Λεπτομέρειες για την επιστροφή χρημάτων",
		"print-receipt": "Εκτύπωση Απόδειξης",
		"request-refund": "Αίτημα επιστροφής χρημάτων",
		"expired": "Έληξε",
		"expires-in": "Ημερομηνία λήξης %{date}",
		"details-refund": "Λεπτομέρειες και επιστροφή χρημάτων",
		"modal": {
			"cant-refund-title": "Μη διαθέσιμη επιστροφή χρημάτων",
			"cant-refund": "Το βιβλίο σας δεν μπορεί να επιστραφεί για έναν ή περισσότερους από τους παρακάτω λόγους.",
			"cant-refund-1": "Μεγάλο τμήμα του βιβλίου σας έχει προβληθεί.",
			"cant-refund-2": "Έχουν περάσει περισσότερες από 14 ημέρες από την ημερομηνία αγοράς.",
			"cant-refund-3": "Ο διαδικτυακός κωδικός πηγών σας έχει αποκαλυφθεί.",
			"cant-refund-4": "Το βιβλίο σας έχει προηγουμένως επιστραφεί.",
			"cant-refund-5": "Όλοι οι κωδικοί έχουν ήδη εξαργυρωθεί ή / και έχει γίνει επιστροφή χρημάτων.",
			"cant-refund-6": "Έχουν περάσει περισσότερες από 30 ημέρες από την ημερομηνία αγοράς.",
			"cant-refund-support": "Αν δεν είστε σίγουροι για την πολιτική επιστροφής του%{brand} επικοινωνήστε  <a href='%{support_url}' target='_blank'>με το τμήμα υποστήριξης</a> ."
		},
		"license": {
			"perpetual": "Η ηλεκτρονική πρόσβαση δεν λήγει",
			"days": "%{days} Πρόσβαση ημέρας "
		}
	},
	"devices": {
		"description": "Το %{brand} σας επιτρέπει να <span>έχετε</span> %{desktop} υπολογιστές και <span>%{mobile}</span> συσκευές κινητών τηλεφώνων/tablet ενεργοποιημένα κάθε στιγμή.",
		"loading": "Αναζητούμε τις συσκευές σας :)",
		"no-active": "Δεν έχετε ενεργοποιημένες συσκευές.",
		"deactivate": "Απενεργοποίηση"
	},
	"user": {
		"personal-information": "Προσωπικά στοιχεία",
		"security-information": "Πληροφορίες ασφαλείας",
		"notifications": "Ειδοποιήσεις",
		"first-name": "Όνομα",
		"last-name": "Επώνυμο",
		"change-password-title": "Αλλαγή κωδικού πρόσβασης",
		"current-password": "Τρέχων κωδικός πρόσβασης",
		"new-password": "Νέος κωδικός πρόσβασης",
		"security-password": "Κωδικός πρόσβασης",
		"confirm-new-password": "Επιβεβαίωση νέου κωδικού πρόσβασης",
		"security-question": "Ερώτηση ασφαλείας",
		"security-info-change": "Αλλαγή",
		"question": "Ερώτηση",
		"answer": "Απάντηση",
		"notifications-text": "Να λαμβάνω περιστασιακά μηνύματα ηλεκτρονικού ταχυδρομείου με ενημερώσεις για τη δραστηριότητα του λογαριασμού μου και ειδικές προσφορές.",
		"loading": "Συλλέγουμε τις πληροφορίες χρήστη, μισό λεπτό🐶",
		"change-password-text": "Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες, ένα κεφαλαίο γράμμα, ένα πεζό γράμμα και έναν ειδικό χαρακτήρα.",
		"email-locked": "Το πεδίο email κλειδώθηκε",
		"email-locked-description": "Δεν έχετε πρόσβαση για να αλλάξετε το email σας.",
		"email-locked-more": "Επικοινωνήστε με το διαχειριστή.",
		"security-question6": "Ποιο είναι το αγαπημένο σας άθλημα;",
		"security-question7": "Ποιά είναι η αγαπημένη σας γεύση παγωτού;",
		"security-question8": "Ποιό είναι το όνομα του αγαπημένου σας κατοικιδίου;",
		"security-question9": "Όταν ήσασταν μικροί, τι θέλατε να γίνετε όταν μεγαλώσετε;",
		"security-question10": "Ποιό είναι το επώνυμο του αγαπημένου δασκάλου σας;",
		"new-password-failure": "Ο κωδικός πρόσβασης δεν πληροί τις προδιαγραφές",
		"confirm-password-failure": "Οι κωδικοί πρόσβασης δεν ταιριάζουν",
		"new-password-tooltip": "Πρέπει να έχει 8 χαρακτήρες τουλάχιστον, ένα κεφαλαίο γράμμα, ένα πεζό γράμμα και έναν ειδικό χαρακτήρα.",
		"enter-valid-email": "Εισαγάγετε μία έγκυρη διεύθυνση ηλεκτρονικού ταχυδρομείου.",
		"password-cannot-be-same": "Ο κωδικός πρόσβασης δεν μπορεί να είναι ίδιος με τον προηγούμενο κωδικό πρόσβασης",
		"incorrect-password": "Λανθασμένος κωδικός πρόσβασης",
		"complete-account": "Φαίνεται ότι πρέπει να <a href='%{href}'>ολοκληρώσετε τη δημιουργία λογαριασμού</a>.",
		"completing-allows": "Η ολοκλήρωση της δημιουργίας του λογαριασμού σας θα σας επιτρέψει να διαβάζετε βιβλία εκτός σύνδεσης σε εφαρμογές κινητού τηλεφώνου και να μοιράζεστε σημειώσεις και επισημάνσεις με τους φίλους σας.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Παραρτήματα",
		"access-codes": "Κωδικοί πρόσβασης",
		"print-on-demand": "Εκτύπωση κατόπιν αιτήματος",
		"check-pod": "Ελέγξτε τις επιλογές εκτύπωσης του εκδότη για τα βιβλία σας.",
		"check-now": "Έλεγχος τώρα",
		"loading": "Περιμένετε, ενημερώνουμε τις πηγές σας!",
		"in": "σε",
		"access-code-intro": "Ο κωδικός πρόσβασης είναι ένας κωδικός που χρησιμοποιείτε για να έχετε ηλεκτρονική πρόσβαση σε περιεχόμενα μαθημάτων. Μόλις αποκαλύψετε τον κωδικό για ένα αντικείμενο, δεν θα είστε σε θέση να το επιστρέψετε. Για περισσότερες οδηγίες για τη χρήση του κωδικού πρόσβασης, επισκεφθείτε την <a href='%{support_url}' target='_blank'>Υποστήριξη</a>.",
		"expires": "Ημερομηνία λήξης",
		"expiration-message": "Περιέχει οδηγίες για τη χρήση του κωδικού πρόσβασής σας.",
		"copy-fail": "Δεν είναι δυνατή η αντιγραφή. Επιλέξτε τον κωδικό και αντιγράψτε τον χειροκίνητα.",
		"launch-site": "Εκκίνηση ιστοσελίδας",
		"launch-book": "Εκκίνηση Book",
		"reveal-code": "Αποκάλυψη κωδικού",
		"no-resources": "Δεν έχετε πηγές.",
		"no-access-codes": "Δεν έχετε κανέναν κωδικό πρόσβασης.",
		"no-ancillaries": "Δεν υπάρχουν παραρτήματα για αυτόν τον τίτλο",
		"name": "Όνομα",
		"type": "Τύπος",
		"size": "Μέγεθος",
		"download-all": "Λήψη όλων",
		"back": "Πίσω στις πηγές"
	},
	"refunds": {
		"states": {
			"refunded": "Έγινε επιστροφή χρημάτων",
			"unavailable": "Μη διαθέσιμη επιστροφή χρημάτων"
		},
		"reasons": {
			"dropped": "Απέρριψα το μάθημα",
			"wrong": "Δεν ήταν το σωστό βιβλίο για το μάθημά μου",
			"print": "Αποφάσισα να αγοράσω έντυπη έκδοση",
			"missing": "Το βιβλίο δεν περιέχει όλα όσα χρειάζομαι για το μάθημά μου (πχ. Ένα CD, πρόσβαση στο διαδίκτυο, βίντεο)",
			"other": "Άλλα"
		},
		"bulk": {
			"policy": "Κάνοντας κλικ στο παρακάτω κουμπί &quot;Πλήρης Επιστροφή&quot;, συμφωνώ με την %{brand} <a href='%{policy_url}' target='_blank'> πολιτική επιστροφής </a> .",
			"complete": "Πλήρης Επιστροφή",
			"view-details": "Δείτε Λεπτομέρειες για την επιστροφή χρημάτων",
			"success": "Υποβλήθηκε αίτημα για την επιστροφή χρημάτων σας. Περιμένετε 48 ώρες για επεξεργασία του αιτήματός σας.",
			"failure": "Ωχ! Κάτι πήγε στραβά! Δυστυχώς η επιστροφή χρημάτων σας δεν ολοκληρώθηκε.",
			"retry": "Δοκιμάστε ξανά",
			"support": "Επικοινωνία με το τμήμα υποστήριξης",
			"available-codes": "Διαθέσιμοι Κωδικοί",
			"codes-selected": "Επιλεγμένοι Κωδικοί",
			"download": "Κωδικοί που έχουν ληφθεί",
			"partially-refunded": "Μερική Επιστροφή Χρημάτων",
			"pick-one": "Πρέπει να επιλέξετε τουλάχιστον έναν κωδικό για να κάνει μια επιστροφή"
		},
		"refund": "Επιστροφή χρημάτων",
		"all": "Επιστροφή χρημάτων για όλα;",
		"missing-reason": "Πρέπει να επιλέξετε ένα λόγο για να συνεχίσετε",
		"missing-elaboration": "Δώστε περισσότερες πληροφορίες",
		"policy": "Κάνοντας κλικ στο παρακάτω κουμπί «Ολοκλήρωση Αιτήματος Επιστροφής Χρημάτων», καταλαβαίνω ότι αν αγοράσω ξανά το συγκεκριμένο %{brand} eTextbook, δεν θα μπορώ να ζητήσω περαιτέρω επιστροφές για τον ίδιο eTextbook. Δείτε την πλήρη πολιτική επιστροφής.",
		"refunded": "Έγινε επιστροφή χρημάτων",
		"sorry": "Λυπούμαστε που δεν μείνατε ικανοποιημένοι από την αγορά σας.",
		"error": "Κάτι δεν πήγε καλά",
		"error-explain": "Δεν κατέστη δυνατό να επεξεργαστούμε την επιστροφή χρημάτων σας. Δοκιμάστε ξανά αργότερα.",
		"why": "Πείτε μας γιατί;",
		"no-refunds": "Δεν έχετε επιστρεφόμενα στοιχεία.",
		"select-codes": "Επιλέξτε τον κωδικό (ούς) για την επιστροφή χρημάτων:",
		"number": "Πόσοι?",
		"back": "Πίσω στις επιστροφές χρημάτων"
	},
	"purchases": {
		"back": "Πίσω στις αγορές"
	},
	"global-bar": {
		"account": "Ρυθμίσεις λογαριασμού"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/el.json
 ** module id = 976
 ** module chunks = 0
 **/